// src/LakersOT.js

import React, { useEffect } from 'react';
import Slider from 'react-slick'; // Import the Slick carousel
import 'slick-carousel/slick/slick.css'; // Import the necessary Slick CSS
import 'slick-carousel/slick/slick-theme.css'; // Import the theme CSS for Slick
import './LakersOT.css'; // Assume custom styles for this component
import SearchBar from './components/SearchBar/SearchBar';
import LakersNavbar from './components/LakersNavBar/LakersNavBar';

<head>
  <meta charset="utf-8" />
  <link rel="icon" href="%PUBLIC_URL%/picz/lakersOT/lakersfavicon.ico" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <meta name="theme-color" content="#000000" />
</head>

const LakersOT = () => {
  // Slick Carousel settings
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
  };
  
  useEffect(() => {
 //   document.body.style.background = 'url("/picz/lakersOT/basketball-court-night.jpg") no-repeat center center';
    document.body.style.backgroundSize = 'cover';
    // Cleanup to reset the style when component unmounts
    return () => {
      document.body.style.background = '';
      document.body.style.backgroundSize = '';
    };
  }, []);

  return (
    <div>
      {/* New Navbar */}
      <LakersNavbar />

      {/* Jumbotron */}
      <div className="jumbotron" style={{ background: 'transparent !important' }}>
        <div className="container text-center">
          <section>
            <div className="advertisement">
              <img src="/picz/lakersOT/ad_toyota_728x90.jpg" alt="Toyota Ad" />
            </div>
            
          <div className='spacer'></div>

            {/* Slick Carousel */}
            <Slider {...settings}>
              <div className="carousel-item">
                <img src="/picz/lakersOT/lakers-team.jpg" alt="Lakers Team" />
                <div className="carousel-caption" style={{ color: 'white' }}>
                  <i>"Julius Randle updates how him and his fellow Lakers are doing as part of the @usabasketball Select Team."</i>
                </div>
              </div>
              <div className="carousel-item">
                <img src="/picz/lakersOT/lakers-brown.jpg" alt="Lakers Brown" />
                <div className="carousel-caption" style={{ color: 'white' }}>
                  <i>"Anthony Brown on his shots starting to fall and how his defense impacts the games."</i>
                </div>
              </div>
              <div className="carousel-item">
                <img src="/picz/lakersOT/lakers-russell.jpg" alt="Lakers Russell" />
                <div className="carousel-caption" style={{ color: 'white' }}>
                  <i>"D'Angelo Russell details who he's looking forward to matching up against at USA camp."</i>
                </div>
              </div>
              <div className="carousel-item">
                <img src="/picz/lakersOT/lakers-brown_ingram.jpg" alt="Lakers Brown Ingram" />
                <div className="carousel-caption" style={{ color: 'white' }}>
                  <i>"Brandon Ingram talks about the first USA Select team practice and reuniting with other Duke players."</i>
                </div>
              </div>
            </Slider>
          </section>
        </div>

        <div className='postGame' id="LakersHighlights">
          <div className='solid-line' style={{margin:'50px 20px 0'}} />
            <img src="/picz/lakersOT/lakerslogo_letterman-removebg-preview.png" alt="Lakers Icon" style={{ width: '80px' }} />
            <h2> Lakers Post Game Coverage </h2>
          </div>
        </div>

      <div className='postGameLinks'>
        <div className="btn-group">
          <a target="_blank" rel="noreferrer" href="https://www.nba.com/lakers/team/roster-coaches?ls=nav_team" className="btn btn-m btn-dark">
            <span>Roster</span>
          </a>
          <a target="_blank" rel="noreferrer" href="http://lakersstore.com/" className="btn btn-m btn-dark">Store</a>
          <a target="_blank" rel="noreferrer" href="https://www.nba.com/lakers/category/team-highlights" className="btn btn-m btn-dark">Latest Highlights</a>
        </div>  

        <div className='spacer'></div>

        <div className="btn-group2">
          <span className="btn btn-m">
            <a href="https://facebook.com/Lakers"><img src="/picz/icons/facebook_icon.png" alt="Facebook Icon" style={{ width: '50%'}} /></a>
          </span>
          <span className="btn btn-m">
            <a href="https://x.com/Lakers"><img src="/picz/icons/x__twitter_icon.png" alt="X-Twitter Icon" style={{ width: '50%', boxShadow: '0 0 5px white, 0 0 10px white'}} /></a>
          </span>
          <span className="btn btn-m">
            <a target="_blank" rel="noreferrer" href="https://www.instagram.com/lakers/">
            <img src="/picz/icons/instagram_icon.png" alt="Instagram Icon" style={{ width: '50%'}} /></a>
          </span>
          <span className="btn btn-m">
            <a target="_blank" rel="noreferrer" href="https://www.youtube.com/lakers/">
            <img src="/picz/icons/iktok_icon.png" alt="TikTok Icon" style={{ width: '50%'}} /></a>
          </span>
        </div> 
      </div>

      {/* Searchbar */}
    <div className='searchBar'>
      <div className="navbar-form navbar-right">
        <SearchBar onSearch={(query) => console.log('Searching for:', query)} />
      </div>
    </div>

      {/* Gallery */}
      <div className="socialContainer">
        <section className='socialSection'>
          <div className="row">
            <div className="col-lg-4">
              <a target="_blank" rel="noreferrer" href="http://www.nba.com/games/20160711/GSWLAL/gameinfo.html">
                <img src="/picz/lakersOT/stats.jpg" alt="Stats" className="img-responsive" />
              </a>
              <br />
              <a target="_blank" rel="noreferrer" href="http://www.nba.com/games/20160711/GSWLAL/gameinfo.html">
                <img src="/picz/lakersOT/scoreboard.jpg" alt="Scoreboard" className="img-responsive" />
              </a>
              <br />
              <a target="_blank" rel="noreferrer" href="http://www.nba.com/games/20160711/GSWLAL/gameinfo.html">
                <img src="/picz/lakersOT/recap.jpg" alt="Recap" className="img-responsive" />
              </a>
              <br />

            </div>
            <div className="col-lg-4">
              <div className='highlights'><h2>Highlights</h2></div>
              <a target="_blank" rel="noreferrer" href="http://www.nba.com/lakers/video/channel/team_highlights/">
                <img src="/picz/lakersOT/articles.jpg" alt="Highlights" className="img-responsive" style={{ padding: '1rem' }} />
              </a>
              <br />
              <div className="embed-responsive embed-responsive-16by9">
                <iframe
                  width="100%"
                  height="240px"
                  src="https://www.youtube.com/embed/625nK8sm5hE"
                  frameBorder="0"
                  allowFullScreen
                  title="YouTube Video"
                ></iframe>
              </div>
              <br />
              <a target="_blank" rel="noreferrer" href="http://order.wingstop.com/">
                <img src="/picz/lakersOT/ad_wingstop_300x250.jpg" alt="Wingstop" className="img-responsive" />
              </a>
            </div>

            <div className="col-lg-4">
              <a target="_blank" rel="noreferrer" href="http://www.nba.com/lakers/gallery/photos-lakers-vs.-jazz-04/13/16-0">
                <img src="/picz/lakersOT/kobe.jpg" alt="Kobe" className="img-responsive" />
              </a>
              <br />
              <a target="_blank" rel="noreferrer" href="https://twitter.com/Lakers">
                <img src="/picz/lakersOT/twitterfeed.jpg" alt="Twitter Feed" className="img-responsive" />
              </a>
              <br />
            </div>
          </div>
        </section>
      </div>
    
    <div className='solid-line'></div>

      {/* Bottom header */}
      <section>
        <div className="subscribeBox" id="LakersSubscribe">
          <div className="container text-center">
            <h3>Subscribe for the latest updates!</h3>
            <form className="subscribe-form">
              <div className="form-group">
                <label htmlFor="subscription">Full Name</label>
                <input
                  type="text"
                  className="form-control"
                  id="subscription"
                  placeholder="Your Name"
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="text"
                  className="form-control"
                  id="email"
                  placeholder="Your Email"
                  name="Enter your Email"
                />
              </div>
              <div className="form-group">
                <button type="submit" className="btn btn-default">Subscribe</button>
              </div>
            </form>
          </div>
        </div>
      </section>


      {/* Footer */}
      <div className='copyrightFooter'>
              <p>
                Copyright © 2016 NBA Media Ventures, LLC. All rights reserved. No portion of NBA.com may be duplicated, redistributed or manipulated in any form. By accessing any information beyond this page, you agree to abide by the Privacy Policy / Your California Privacy Rights and Terms of Use | Ad Choices
              </p>
              <div className="col-md-10" style={{ paddingLeft: '0px' }}>
                <div className="tuner-logo">
                  <p>
                    <span style={{ paddingRight: '3px', paddingTop: '3px' }}>
                      <img src="/picz/lakersOT/turnerlogo.jpg" alt="Turner Sports Logo" />
                    </span>
                    NBA.com is part of Turner Sports Digital, part of the Turner Sports & Entertainment Digital Network.
                  </p>
                </div>
              </div>
            </div>
          </div>

  );
};

export default LakersOT;
